"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AverageScoreToJSON = exports.AverageScoreFromJSONTyped = exports.AverageScoreFromJSON = void 0;
function AverageScoreFromJSON(json) {
    return AverageScoreFromJSONTyped(json, false);
}
exports.AverageScoreFromJSON = AverageScoreFromJSON;
function AverageScoreFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'gross': json['gross'],
        'net': json['net'],
    };
}
exports.AverageScoreFromJSONTyped = AverageScoreFromJSONTyped;
function AverageScoreToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'gross': value.gross,
        'net': value.net,
    };
}
exports.AverageScoreToJSON = AverageScoreToJSON;
